import { useContext, useEffect, useState } from "react";
import "../../../../../styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/NewCustomerUser.css";
import {usersMicroserviceUrl} from "../../../../../microservices/users_microservice.js";
import { thingsBoardMicroserviceUrl } from "../../../../../microservices/thingsboard_microservice.js";
import { CustomerContext } from "./../CustomerProvider.jsx";
import { AppContext } from "./../../../../AppProvider.jsx";
import countries from "../../../../../functions/getCountries";
const NewCustomerUser = ({showNewCustomerUserWindow,setShowNewCustomerUserWindow,customer}) =>{
    const {user,logout} = useContext(AppContext)
    const {selectedTenantAdminProfile,setReloadCustomerUsers} = useContext(CustomerContext);
    const [countryFilterString,setCountryFilterString] = useState('');
    const [showCountriesBrowser,setShowCountriesBrowser] = useState(false);
    const [createCustomerUserStatus,setCreateCustomerUserStatus] = useState('');
    const [firstName,setFirstName] = useState('');
    const [lastName,setLastName] = useState('');
    const [emailAddress,setEmailAddress] = useState('');
    const [password,setPassword] = useState('');
    const [selectedRole,setSelectedRole] = useState('select');
    const [selectedCountry,setSelectedCountry] = useState(null);
    const [city,setCity] = useState('');
    const [phoneNumber,setPhoneNumber] = useState('');
    const [postalCode,setZipCode] = useState('');
    const [address,setAddress] = useState('');
    const [address2,setAddress2] = useState('');
    const createCustomerUser = async() =>{
        setCreateCustomerUserStatus('creating');
        const newCustomerUserPayload = {
            firstName:firstName,
            lastName:lastName,
            emailAddress:emailAddress,
            password:password,
            country:selectedCountry,
            city:city,
            phoneNumber:phoneNumber,
            postalCode:postalCode,
            address:address,
            address2:address2
        };
        const url = `${usersMicroserviceUrl}/tenants/customer-users`;
        try{
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                },
                body:JSON.stringify(newCustomerUserPayload)
            });
            if(response.ok) setCreateCustomerUserStatus('created');
            else if(response.status === 401) logout();
            else if(response.status === 409) setCreateCustomerUserStatus('create-conflict');
            else if(response.status === 500) setCreateCustomerUserStatus('create-error');
        }
        catch(error){
            console.error(error);
        }
        return false;
    };
    const registerCustomerUser = async() => {
        try{
            setCreateCustomerUserStatus('registering');
            const customerUserPayload = {
                username:emailAddress,
                customerId:customer?.local?.id,
                role:selectedRole
            };
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/customers/users`;
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                },
                body:JSON.stringify(customerUserPayload)
            });
            if(response.ok) setCreateCustomerUserStatus('registered');
            else if(response.status === 401) logout();
            else if(response.status === 409) setCreateCustomerUserStatus('register-conflict');
            else setCreateCustomerUserStatus('register-error');
        }
        catch(error){
            console.error('Unexpected error occurred when registering customer user to the IOT service',error);
            setCreateCustomerUserStatus('register-error');
        }
        return false;
    };
    const clearEntries = () =>{
        setCountryFilterString('');
        setShowCountriesBrowser(false);
        setFirstName('');
        setLastName('');
        setEmailAddress('');
        setPassword('');
        setSelectedRole('select');
        setSelectedCountry(null);
        setCity('');
        setPhoneNumber('');
        setZipCode('');
        setAddress('');
        setAddress2('');
    };
    const disposeWindow = () =>{
        clearEntries();
        setCreateCustomerUserStatus('');
        setShowNewCustomerUserWindow(false);
    };
    const validFormToolTipText = () =>{
        if(firstName === '') return 'Enter the first name to proceed';
        if(lastName === '') return 'Enter the last name to proceed';
        if(emailAddress === '') return 'Enter a valid email address to proceed';
        if(password === '') return 'Enter a valid password to proceed';
        if(selectedRole === 'select') return "Select the user's role to proceed";
        if(selectedCountry === '') return "Select the user's country to proceed";
        if(city === '') return "Enter city name to proceed";
        return '';
    };
    useEffect(() =>{
        document.title = 'Blink IOT | Create customer user';
        const handleEsc = (e) =>{
            if(e.key === "Escape" && (createCustomerUserStatus === 'registered' || createCustomerUserStatus === 'create-conflict' || createCustomerUserStatus === 'create-error' || createCustomerUserStatus === 'register-error')) disposeWindow();
        };
        document.addEventListener("keydown",handleEsc);
        return () =>{
            document.removeEventListener("keydown",handleEsc);
        };
    },[createCustomerUserStatus]);
    useEffect(() =>{
        if(createCustomerUserStatus === 'created') registerCustomerUser();
        else if(createCustomerUserStatus === 'registered') setReloadCustomerUsers(true);
    },[createCustomerUserStatus]);
    if(!showNewCustomerUserWindow) return null;
    return(
        <div className="tenant-administrator-new-customer-user-parent-container">
            {createCustomerUserStatus === ''?
                (
                    <div className="tenant-administrator-new-customer-user-container">
                        <div className="tenant-administrator-new-customer-user-header">
                            <h1>Add user</h1>
                            <p onClick={() => disposeWindow()}>
                                &#10006;
                            </p>
                        </div>
                        <div className="tenant-administrator-new-customer-user-body">
                            <div className="tenant-administrator-new-customer-user-entry-container">
                                <p>First name<span>*</span></p>
                                <input
                                    placeholder="Enter first name"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                />
                            </div>
                            <div className="tenant-administrator-new-customer-user-entry-container">
                                <p>Last name<span>*</span></p>
                                <input
                                    placeholder="Enter last name"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                />
                            </div>
                            <div className="tenant-administrator-new-customer-user-entry-container">
                                <p>Email address<span>*</span></p>
                                <input
                                    placeholder="Enter email address"
                                    value={emailAddress}
                                    onChange={(e) => setEmailAddress(e.target.value)}
                                />
                            </div>
                            <div className="tenant-administrator-new-customer-user-entry-container">
                                <p>Password<span>*</span></p>
                                <input
                                    placeholder="Enter password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                            <div className="tenant-administrator-new-customer-user-entry-container">
                                <p>Role<span>*</span></p>
                                <select value={selectedRole} onChange={(e) => setSelectedRole(e.target.value)}>
                                    <option value="select" disabled>Select Role</option>
                                    <option value="ADMIN">Administrator</option>
                                    <option value="USER">User</option>
                                </select>
                            </div>
                            <div className="tenant-administrator-new-customer-user-entry-container">
                                <p>Country<span>*</span></p>
                                {selectedCountry?
                                    (
                                        <div className="tenant-administrator-new-customer-user-selected-country-display">
                                            <p>{selectedCountry}</p>
                                            <p className="cancel-p" onClick={() => setSelectedCountry(null)}>&#10006;</p>
                                        </div>
                                    ):
                                    (
                                        <input
                                            placeholder="Select country"
                                            value={countryFilterString}
                                            onChange={(e) => setCountryFilterString(e.target.value)}
                                            onFocus={() => setShowCountriesBrowser(true)}
                                            onBlur={() => setTimeout(() =>{setShowCountriesBrowser(false)},150)}
                                        />
                                    )
                                }
                                <div className={`tenant-administrator-new-customer-user-countries-browser ${showCountriesBrowser? 'active':''}`}>
                                    {[...countries].filter(country => country.toLowerCase().includes(countryFilterString?.toLowerCase())).
                                        sort((a,b) => a.localeCompare(b)).map((country) =>(
                                        <div key={country} onClick={() =>{
                                            setSelectedCountry(country);
                                            setCountryFilterString('');
                                        }}>
                                            {country}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="tenant-administrator-new-customer-user-entry-container">
                                <p>City<span>*</span></p>
                                <input
                                    placeholder="Enter city name"
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                />
                            </div>
                            <div className="tenant-administrator-new-customer-user-entry-container">
                                <p>Phone number</p>
                                <input
                                    placeholder="Enter phone number"
                                    value={phoneNumber}
                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                />
                            </div>
                            <div className="tenant-administrator-new-customer-user-entry-container">
                                <p>Zip/Postal code</p>
                                <input
                                    placeholder="Enter zip/postal code"
                                    value={postalCode}
                                    onChange={(e) => setZipCode(e.target.value)}
                                />
                            </div>
                            <div className="tenant-administrator-new-customer-user-entry-container">
                                <p>Address</p>
                                <input
                                    placeholder="Enter address"
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                />
                            </div>
                            <div className="tenant-administrator-new-customer-user-entry-container">
                                <p>Address 2</p>
                                <input
                                    placeholder="Enter address 2"
                                    value={address2}
                                    onChange={(e) => setAddress2(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="tenant-administrator-new-customer-user-buttons-container">
                            <button className="cancel" onClick={() => disposeWindow()}>Cancel</button>
                            <button
                                className={`add ${validFormToolTipText() === ''? 'active':'inactive'}`}
                                title={validFormToolTipText()}
                                onClick={async () => {
                                    if(validFormToolTipText() !== '') return;
                                    createCustomerUser();
                                }}>Add</button>
                        </div>
                    </div>
                ):createCustomerUserStatus === 'creating' || createCustomerUserStatus === 'created'?
                (
                    <div className="tenant-administrator-new-customer-user-creating-container">
                        <div></div>
                        <p>Creating customer user. Please wait...</p>
                    </div>
                ):createCustomerUserStatus === 'registering'?
                (
                    <div className="tenant-administrator-new-customer-user-registering-container">
                        <div></div>
                        <p>Registering customer user. Please wait...</p>
                    </div>
                ):createCustomerUserStatus === 'registered'?
                (
                    <div className="tenant-administrator-new-customer-user-created-registered-container">
                        <div className="details-container">
                            <p>Customer user successfully created and registered on the IOT service</p>
                            <div>
                                <button onClick={() => disposeWindow()}>Okay</button>
                            </div>
                        </div>
                        <div className="tenant-administrator-new-customer-user-created-registered-escape-button-container"
                            onClick={() => disposeWindow()}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):createCustomerUserStatus === 'create-conflict'?
                (
                    <div className="tenant-administrator-new-customer-user-create-conflict-container">
                        <div className="details-container">
                            <p>Couldn't create customer user</p>
                            <p>An account with the provided email already exists</p>
                            <div>
                                <button onClick={() => disposeWindow()}>Okay</button>
                            </div>
                        </div>
                        <div className="tenant-administrator-new-customer-user-create-conflict-escape-button-container"
                            onClick={() => disposeWindow()}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):createCustomerUserStatus === 'create-error'?
                (
                    <div className="tenant-administrator-new-customer-user-create-error-container">
                        <div className="details-container">
                            <p>Unexpected error occurred when creating customer user</p>
                            <div>
                                <button onClick={() => disposeWindow()}>Okay</button>
                            </div>
                        </div>
                        <div className="tenant-administrator-new-customer-user-create-error-escape-button-container"
                            onClick={() => disposeWindow()}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):createCustomerUserStatus === 'register-error'?
                (
                    <div className="tenant-administrator-new-customer-user-create-error-container">
                        <div className="details-container">
                            <p>Unexpected error occurred when registering customer user</p>
                            <div>
                                <button onClick={() => disposeWindow()}>Okay</button>
                            </div>
                        </div>
                        <div className="tenant-administrator-new-customer-user-create-error-escape-button-container"
                            onClick={() => disposeWindow()}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):
                (
                    <div className="tenant-administrator-new-customer-user-unknown-error-container">
                        <div className="details-container">
                            <p>Unexpected error occurred</p>
                            <div>
                                <button onClick={() => disposeWindow()}>Okay</button>
                            </div>
                        </div>
                        <div className="tenant-administrator-new-customer-user-unknown-error-button-container"
                            onClick={() => disposeWindow()}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                )
            }
        </div>
    );
};
export default NewCustomerUser;